const data = {
  title: "Floor 5-1",
  musicTrack: "MUSIC_WORLD1",
  story: "FLOOR FIVE - ALL IN THE LOGISTICS",
  theme: "YELLOW",
  tilesWidth: 8,
  tilesHeight: 14,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 3,
      y: 1,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 6,
      y: 6,
    },
    {
      type: "WALL",
      x: 7,
      y: 3,
    },
    {
      type: "WALL",
      x: 5,
      y: 3,
    },
    {
      type: "WALL",
      x: 6,
      y: 2,
    },
    {
      type: "WATER",
      x: 1,
      y: 3,
    },
    {
      type: "WATER",
      x: 2,
      y: 3,
    },
    {
      type: "SWITCH_WALL",
      x: 2,
      y: 2,
      isRaised: true,
    },
    {
      type: "THIEF",
      x: 1,
      y: 1,
    },
    {
      type: "CHIP",
      x: 1,
      y: 2,
    },
    {
      type: "CHIP",
      x: 6,
      y: 3,
    },
    {
      type: "FIRE_BOOTS",
      x: 1,
      y: 5,
    },
    {
      type: "ENEMY_SPAWN",
      x: 1,
      y: 4,
      direction: "DOWN",
      enemyType: "FLYING_ENEMY",
    },
    {
      type: "WALL",
      x: 1,
      y: 8,
    },
    {
      type: "WALL",
      x: 2,
      y: 8,
    },
    {
      type: "FIRE",
      x: 7,
      y: 5,
    },
    {
      type: "FIRE",
      x: 7,
      y: 6,
    },
    {
      type: "FIRE",
      x: 7,
      y: 7,
    },
    {
      type: "FIRE",
      x: 7,
      y: 8,
    },
    {
      type: "FIRE",
      x: 8,
      y: 8,
    },
    {
      type: "FIRE",
      x: 8,
      y: 5,
    },
    {
      type: "SWITCH",
      x: 8,
      y: 7,
    },
    {
      type: "WATER_PICKUP",
      x: 8,
      y: 6,
    },
    {
      type: "ICE",
      x: 3,
      y: 7,
    },
    {
      type: "ICE",
      x: 3,
      y: 8,
    },
    {
      type: "ICE",
      x: 5,
      y: 7,
    },
    {
      type: "ICE",
      x: 5,
      y: 8,
    },
    {
      type: "ICE",
      x: 5,
      y: 9,
    },
    {
      type: "ICE",
      x: 3,
      y: 9,
    },
    {
      type: "ICE",
      x: 3,
      y: 10,
    },
    {
      type: "ICE",
      x: 2,
      y: 11,
    },
    {
      type: "ICE",
      x: 2,
      y: 10,
    },
    {
      type: "ICE",
      x: 1,
      y: 11,
      corner: "BOTTOM_LEFT",
    },
    {
      type: "ICE",
      x: 1,
      y: 10,
      corner: "TOP_LEFT",
    },
    {
      type: "ICE",
      x: 3,
      y: 11,
      corner: "BOTTOM_RIGHT",
    },
    {
      type: "ICE",
      x: 5,
      y: 11,
      corner: "BOTTOM_LEFT",
    },
    {
      type: "ICE",
      x: 5,
      y: 10,
    },
    {
      type: "LOCK",
      x: 4,
      y: 11,
      color: "GREEN",
    },
    {
      type: "ICE",
      x: 6,
      y: 10,
    },
    {
      type: "ICE",
      x: 6,
      y: 11,
    },
    {
      type: "ICE",
      x: 7,
      y: 10,
    },
    {
      type: "ICE",
      x: 7,
      y: 11,
    },
    {
      type: "ICE",
      x: 8,
      y: 10,
    },
    {
      type: "ICE",
      x: 8,
      y: 11,
      corner: "BOTTOM_RIGHT",
    },
    {
      type: "ICE",
      x: 8,
      y: 9,
    },
    {
      type: "ICE_BOOTS",
      x: 1,
      y: 9,
    },
    {
      type: "SWITCH",
      x: 2,
      y: 9,
    },
    {
      type: "WALL",
      x: 7,
      y: 2,
    },
    {
      type: "WALL",
      x: 5,
      y: 2,
    },
    {
      type: "ENEMY_SPAWN",
      x: 7,
      y: 4,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
    {
      type: "WALL",
      x: 6,
      y: 7,
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 12,
      isRaised: true,
    },
    {
      type: "WALL",
      x: 3,
      y: 14,
    },
    {
      type: "WALL",
      x: 3,
      y: 13,
    },
    {
      type: "WALL",
      x: 6,
      y: 13,
    },
    {
      type: "WALL",
      x: 6,
      y: 14,
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 12,
      isRaised: true,
    },
    {
      type: "ENEMY_SPAWN",
      x: 5,
      y: 13,
      enemyType: "ROAMING_ENEMY",
    },
    {
      type: "CHIP",
      x: 4,
      y: 14,
    },
    {
      type: "CHIP",
      x: 1,
      y: 14,
    },
    {
      type: "CHIP",
      x: 7,
      y: 14,
    },
    {
      type: "KEY",
      x: 6,
      y: 1,
      color: "GREEN",
    },
    {
      type: "WATER",
      x: 5,
      y: 1,
    },
    {
      type: "WALL",
      x: 4,
      y: 5,
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 1,
      direction: "RIGHT",
    },
  ],
};

export default data;
